export const DEFAULT_MAPLABEL_PREVIEW_WIDTH = 200;
const DEFAULT_MAPLABEL_PREVIEW_HEIGHT = 48;

export const DEFAULT_MAPLABEL_TARGET_WIDTH = 220;
export const MAPLABEL_DOT_SIZE = 16;
export const MAPLABEL_CONNECTOR_HEIGHT = 44;
export const MAPLABEL_CONNECTOR_OVERLAP = 32;
export const MAPLABEL_TEXT_AREA_HEIGHT = 30;

// Marker artwork shares one optical text baseline measured from the bottom of
// the SVG canvas. Anchoring text from that edge keeps top decorations (fort
// teeth, chest horns, etc.) from pulling the title out of the label body.
export const MAPLABEL_TEXT_CENTER_FROM_ASSET_BOTTOM = 36;

// MapLibre positions the full SVG from its bottom edge. Keep these values
// shared by every map surface so the title, artwork, connector, and dot use the
// same coordinate contract.
export const MAPLABEL_MAP_ICON_OFFSET_Y = -10;
export const MAPLABEL_MAP_TEXT_SIZE = 14;
export const MAPLABEL_MAP_TEXT_OFFSET_Y =
  (MAPLABEL_MAP_ICON_OFFSET_Y - MAPLABEL_TEXT_CENTER_FROM_ASSET_BOTTOM) /
  MAPLABEL_MAP_TEXT_SIZE;
export const MAPLABEL_MAP_CONNECTOR_END_TUCK = 18;

export const MAPLABELS = [
  {
    id: "bubble-blue",
    src: "/assets/markers/bubble-blue.svg",
    shapeKey: "bubble-pill",
    colorKey: "blue",
    dotColor: "#0073FF",
    width: 234,
    height: 59,
    targetWidth: 220,
  },
  {
    id: "bubble-green",
    src: "/assets/markers/bubble-green.svg",
    shapeKey: "bubble-angled",
    colorKey: "blue",
    dotColor: "#0073FF",
    width: 234,
    height: 59,
    targetWidth: 220,
  },
  {
    id: "bubble-gold",
    src: "/assets/markers/bubble-gold.svg",
    shapeKey: "bubble-rounded-rect",
    colorKey: "blue",
    dotColor: "#0073FF",
    width: 230,
    height: 55,
    targetWidth: 220,
  },
  {
    id: "bubble-gradient",
    src: "/assets/markers/bubble-gradient.svg",
    shapeKey: "bubble-slant",
    colorKey: "blue",
    dotColor: "#0073FF",
    width: 238,
    height: 55,
    targetWidth: 220,
  },
  {
    id: "flare-blue",
    src: "/assets/markers/flare-blue.svg",
    dotColor: "#0073FF",
    width: 230,
    height: 55,
    targetWidth: 220,
  },
  {
    id: "arc-blue",
    src: "/assets/markers/arc-blue.svg",
    dotColor: "#0073FF",
    width: 230,
    height: 55,
    targetWidth: 220,
  },
  {
    id: "ribbon-blue",
    src: "/assets/markers/ribbon-blue.svg",
    dotColor: "#0073FF",
    width: 228,
    height: 55,
    targetWidth: 220,
  },
  {
    id: "notch-blue",
    src: "/assets/markers/notch-blue.svg",
    dotColor: "#0073FF",
    width: 230,
    height: 55,
    targetWidth: 220,
  },
  {
    id: "fort-blue",
    src: "/assets/markers/fort-blue.svg",
    dotColor: "#2CB8FF",
    width: 234,
    height: 70,
    premiumOnly: true,
    targetWidth: 220,
  },
  {
    id: "fort-green",
    src: "/assets/markers/fort-green.svg",
    dotColor: "#62E1D0",
    width: 234,
    height: 70,
    premiumOnly: true,
    targetWidth: 220,
  },
  {
    id: "fort-gradient",
    src: "/assets/markers/fort-gradient.svg",
    dotColor: "#C07AFF",
    width: 234,
    height: 70,
    premiumOnly: true,
    targetWidth: 220,
  },
  {
    id: "fort-pink",
    src: "/assets/markers/fort-pink.svg",
    dotColor: "#FF6CA8",
    width: 234,
    height: 70,
    premiumOnly: true,
    targetWidth: 220,
  },
  {
    id: "ribbon-pink",
    src: "/assets/markers/ribbon-pink.svg",
    dotColor: "#FF4A97",
    width: 254,
    height: 59,
    premiumOnly: true,
    targetWidth: 240,
  },
  {
    id: "slant-teal",
    src: "/assets/markers/slant-teal.svg",
    dotColor: "#5CE2D8",
    width: 264,
    height: 59,
    premiumOnly: true,
    targetWidth: 250,
  },
  {
    id: "slant-cyan",
    src: "/assets/markers/slant-cyan.svg",
    dotColor: "#2ACBFF",
    width: 264,
    height: 59,
    premiumOnly: true,
    targetWidth: 250,
  },
  {
    id: "slant-mint",
    src: "/assets/markers/slant-mint.svg",
    dotColor: "#62E1D0",
    width: 264,
    height: 59,
    premiumOnly: true,
    targetWidth: 250,
  },
  {
    id: "slant-iridescent",
    src: "/assets/markers/slant-iridescent.svg",
    dotColor: "#C07AFF",
    width: 264,
    height: 59,
    premiumOnly: true,
    targetWidth: 250,
  },
  {
    id: "slant-rose",
    src: "/assets/markers/slant-rose.svg",
    dotColor: "#FF6CA8",
    width: 264,
    height: 59,
    premiumOnly: true,
    targetWidth: 250,
  },
  {
    id: "slant-amber",
    src: "/assets/markers/slant-amber.svg",
    dotColor: "#FFB347",
    width: 264,
    height: 59,
    premiumOnly: true,
    targetWidth: 250,
  },
  {
    id: "ribbon-amber",
    src: "/assets/markers/ribbon-amber.svg",
    dotColor: "#FFB347",
    width: 254,
    height: 59,
    premiumOnly: true,
    targetWidth: 240,
  },
  {
    id: "ribbon-cyan",
    src: "/assets/markers/ribbon-cyan.svg",
    dotColor: "#2ACBFF",
    width: 254,
    height: 59,
    premiumOnly: true,
    targetWidth: 240,
  },
  {
    id: "ribbon-mint",
    src: "/assets/markers/ribbon-mint.svg",
    dotColor: "#62E1D0",
    width: 254,
    height: 59,
    premiumOnly: true,
    targetWidth: 240,
  },
  {
    id: "ribbon-iridescent",
    src: "/assets/markers/ribbon-iridescent.svg",
    dotColor: "#C07AFF",
    width: 254,
    height: 59,
    premiumOnly: true,
    targetWidth: 240,
  },
  {
    id: "slant-magenta",
    src: "/assets/markers/slant-magenta.svg",
    dotColor: "#FF5DA2",
    width: 264,
    height: 59,
    premiumOnly: true,
    targetWidth: 250,
  },
  {
    id: "ribbon-confetti",
    src: "/assets/markers/ribbon-confetti.svg",
    dotColor: "#C07AFF",
    width: 254,
    height: 59,
    premiumOnly: true,
    targetWidth: 240,
  },
  {
    id: "fort-amber",
    src: "/assets/markers/fort-amber.svg",
    dotColor: "#FFB347",
    width: 234,
    height: 70,
    premiumOnly: true,
    targetWidth: 220,
  },
  {
    id: "fort-mint",
    src: "/assets/markers/fort-mint.svg",
    dotColor: "#62E1D0",
    width: 234,
    height: 70,
    premiumOnly: true,
    targetWidth: 220,
  },
  {
    id: "fort-aqua",
    src: "/assets/markers/fort-aqua.svg",
    dotColor: "#2ACBFF",
    width: 234,
    height: 70,
    premiumOnly: true,
    targetWidth: 220,
  },
  {
    id: "fort-pink-spark",
    src: "/assets/markers/fort-pink-spark.svg",
    dotColor: "#FF6CA8",
    width: 234,
    height: 70,
    premiumOnly: true,
    targetWidth: 220,
  },
  {
    id: "fort-gold-spark",
    src: "/assets/markers/fort-gold-spark.svg",
    dotColor: "#FFB347",
    width: 234,
    height: 70,
    premiumOnly: true,
    targetWidth: 220,
  },
  {
    id: "fort-aurora-spark",
    src: "/assets/markers/fort-aurora-spark.svg",
    dotColor: "#C07AFF",
    width: 234,
    height: 70,
    premiumOnly: true,
    targetWidth: 220,
  },
  {
    id: "slant-gold",
    src: "/assets/markers/slant-gold.svg",
    dotColor: "#FFB347",
    width: 264,
    height: 59,
    premiumOnly: true,
    targetWidth: 250,
  },
  {
    id: "slant-blue",
    src: "/assets/markers/slant-blue.svg",
    dotColor: "#2ACBFF",
    width: 264,
    height: 59,
    premiumOnly: true,
    targetWidth: 250,
  },
  {
    id: "ribbon-blue-premium",
    src: "/assets/markers/ribbon-blue-premium.svg",
    dotColor: "#2ACBFF",
    width: 254,
    height: 59,
    premiumOnly: true,
    targetWidth: 240,
  },
  {
    id: "slant-dawn",
    src: "/assets/markers/slant-dawn.svg",
    dotColor: "#C07AFF",
    width: 264,
    height: 59,
    premiumOnly: true,
    targetWidth: 250,
  },
  {
    id: "ribbon-sakura",
    src: "/assets/markers/ribbon-sakura.svg",
    dotColor: "#FF6CA8",
    width: 254,
    height: 59,
    premiumOnly: true,
    targetWidth: 240,
  },
  {
    id: "ribbon-gold",
    src: "/assets/markers/ribbon-gold.svg",
    dotColor: "#FFB347",
    width: 254,
    height: 59,
    premiumOnly: true,
    targetWidth: 240,
  },
  {
    id: "ribbon-seafoam",
    src: "/assets/markers/ribbon-seafoam.svg",
    dotColor: "#62E1D0",
    width: 254,
    height: 59,
    premiumOnly: true,
    targetWidth: 240,
  },
  {
    id: "chest-crate-blue",
    src: "/assets/markers/chest-crate-blue.svg",
    dotColor: "#0073FF",
    width: 230,
    height: 60,
    treasureChestOnly: true,
    targetWidth: 220,
  },
  {
    id: "chest-banner-blue",
    src: "/assets/markers/chest-banner-blue.svg",
    dotColor: "#0073FF",
    width: 251,
    height: 55,
    treasureChestOnly: true,
    targetWidth: 240,
  },
  {
    id: "chest-wave-blue",
    src: "/assets/markers/chest-wave-blue.svg",
    dotColor: "#0073FF",
    width: 230,
    height: 60,
    treasureChestOnly: true,
    targetWidth: 220,
  },
  {
    id: "chest-block-gradient",
    src: "/assets/markers/chest-block-gradient.svg",
    dotColor: "#C07AFF",
    width: 230,
    height: 60,
    treasureChestOnly: true,
    targetWidth: 220,
  },
  {
    id: "chest-banner-gradient",
    src: "/assets/markers/chest-banner-gradient.svg",
    dotColor: "#C07AFF",
    width: 251,
    height: 55,
    treasureChestOnly: true,
    targetWidth: 240,
  },
  {
    id: "chest-wave-gradient",
    src: "/assets/markers/chest-wave-gradient.svg",
    dotColor: "#C07AFF",
    width: 230,
    height: 60,
    treasureChestOnly: true,
    targetWidth: 220,
  },
  {
    id: "chest-crate-pink",
    src: "/assets/markers/chest-crate-pink.svg",
    dotColor: "#FF6CA8",
    width: 230,
    height: 60,
    treasureChestOnly: true,
    targetWidth: 220,
  },
  {
    id: "chest-banner-pink",
    src: "/assets/markers/chest-banner-pink.svg",
    dotColor: "#FF6CA8",
    width: 251,
    height: 55,
    treasureChestOnly: true,
    targetWidth: 240,
  },
  {
    id: "chest-wave-pink",
    src: "/assets/markers/chest-wave-pink.svg",
    dotColor: "#FF6CA8",
    width: 230,
    height: 60,
    treasureChestOnly: true,
    targetWidth: 220,
  },
  {
    id: "chest-crate-gold",
    src: "/assets/markers/chest-crate-gold.svg",
    dotColor: "#FFB347",
    width: 230,
    height: 60,
    treasureChestOnly: true,
    targetWidth: 220,
  },
  {
    id: "chest-banner-gold",
    src: "/assets/markers/chest-banner-gold.svg",
    dotColor: "#FFB347",
    width: 251,
    height: 55,
    treasureChestOnly: true,
    targetWidth: 240,
  },
  {
    id: "chest-wave-gold",
    src: "/assets/markers/chest-wave-gold.svg",
    dotColor: "#FFB347",
    width: 230,
    height: 60,
    treasureChestOnly: true,
    targetWidth: 220,
  },
  {
    id: "chest-crate-cyan",
    src: "/assets/markers/chest-crate-cyan.svg",
    dotColor: "#2ACBFF",
    width: 230,
    height: 60,
    treasureChestOnly: true,
    targetWidth: 220,
  },
  {
    id: "chest-banner-cyan",
    src: "/assets/markers/chest-banner-cyan.svg",
    dotColor: "#2ACBFF",
    width: 251,
    height: 55,
    treasureChestOnly: true,
    targetWidth: 240,
  },
  {
    id: "chest-wave-cyan",
    src: "/assets/markers/chest-wave-cyan.svg",
    dotColor: "#2ACBFF",
    width: 230,
    height: 60,
    treasureChestOnly: true,
    targetWidth: 220,
  },
  {
    id: "chest-crate-blue-alt",
    src: "/assets/markers/chest-crate-blue-alt.svg",
    dotColor: "#2ACBFF",
    width: 230,
    height: 60,
    treasureChestOnly: true,
    targetWidth: 220,
  },
  {
    id: "chest-banner-blue-alt",
    src: "/assets/markers/chest-banner-blue-alt.svg",
    dotColor: "#2ACBFF",
    width: 251,
    height: 55,
    treasureChestOnly: true,
    targetWidth: 240,
  },
  {
    id: "chest-wave-blue-alt",
    src: "/assets/markers/chest-wave-blue-alt.svg",
    dotColor: "#2ACBFF",
    width: 230,
    height: 60,
    treasureChestOnly: true,
    targetWidth: 220,
  },
  {
    id: "chest-horn-cyan",
    src: "/assets/markers/chest-horn-cyan.svg",
    dotColor: "#2ACBFF",
    width: 230,
    height: 74,
    treasureChestOnly: true,
    targetWidth: 220,
  },
  {
    id: "chest-horn-gradient",
    src: "/assets/markers/chest-horn-gradient.svg",
    dotColor: "#C07AFF",
    width: 230,
    height: 74,
    treasureChestOnly: true,
    targetWidth: 220,
  },
  {
    id: "chest-horn-pink",
    src: "/assets/markers/chest-horn-pink.svg",
    dotColor: "#FF6CA8",
    width: 230,
    height: 74,
    treasureChestOnly: true,
    targetWidth: 220,
  },
  {
    id: "chest-horn-gold",
    src: "/assets/markers/chest-horn-gold.svg",
    dotColor: "#FFB347",
    width: 230,
    height: 74,
    treasureChestOnly: true,
    targetWidth: 220,
  },
  {
    id: "chest-horn-cyan-alt",
    src: "/assets/markers/chest-horn-cyan-alt.svg",
    dotColor: "#2ACBFF",
    width: 230,
    height: 74,
    treasureChestOnly: true,
    targetWidth: 220,
  },
  {
    id: "chest-horn-blue",
    src: "/assets/markers/chest-horn-blue.svg",
    dotColor: "#0073FF",
    width: 230,
    height: 74,
    treasureChestOnly: true,
    targetWidth: 220,
  },
];

export const getMapLabelById = (id) =>
  MAPLABELS.find((label) => label.id === id) || null;

export const getMapLabelBySrc = (src) =>
  MAPLABELS.find((label) => label.src === src) || null;

export const getMapLabelTargetWidth = (
  label,
  baseWidth = DEFAULT_MAPLABEL_TARGET_WIDTH
) => {
  const target = Number(label?.targetWidth);
  return Number.isFinite(target) && target > 0 ? target : baseWidth;
};

export const getMapLabelPreviewWidth = (
  label,
  previewBaseWidth = DEFAULT_MAPLABEL_PREVIEW_WIDTH,
  mapBaseWidth = DEFAULT_MAPLABEL_TARGET_WIDTH
) => {
  const targetWidth = getMapLabelTargetWidth(label, mapBaseWidth);
  return Math.round((previewBaseWidth * targetWidth) / mapBaseWidth);
};

export const getMapLabelPreviewHeight = (
  label,
  previewBaseWidth = DEFAULT_MAPLABEL_PREVIEW_WIDTH,
  mapBaseWidth = DEFAULT_MAPLABEL_TARGET_WIDTH,
  fallbackHeight = DEFAULT_MAPLABEL_PREVIEW_HEIGHT
) => {
  const previewWidth = getMapLabelPreviewWidth(label, previewBaseWidth, mapBaseWidth);
  const assetWidth = Number(label?.width);
  const assetHeight = Number(label?.height);
  if (!Number.isFinite(assetWidth) || !Number.isFinite(assetHeight) || assetWidth <= 0 || assetHeight <= 0) {
    return fallbackHeight;
  }
  return Math.max(fallbackHeight, Math.round((previewWidth * assetHeight) / assetWidth));
};

export const getMapLabelPreviewTextCenterY = (
  label,
  previewBaseWidth = DEFAULT_MAPLABEL_PREVIEW_WIDTH,
  mapBaseWidth = DEFAULT_MAPLABEL_TARGET_WIDTH
) => {
  const previewWidth = getMapLabelPreviewWidth(label, previewBaseWidth, mapBaseWidth);
  const previewHeight = getMapLabelPreviewHeight(label, previewBaseWidth, mapBaseWidth);
  const assetWidth = Number(label?.width);
  const textCenterFromBottom = Number(label?.textCenterFromBottom);
  const sourceTextCenterFromBottom =
    Number.isFinite(textCenterFromBottom) && textCenterFromBottom > 0
      ? textCenterFromBottom
      : MAPLABEL_TEXT_CENTER_FROM_ASSET_BOTTOM;

  if (!Number.isFinite(assetWidth) || assetWidth <= 0) {
    return previewHeight / 2;
  }

  const assetScale = previewWidth / assetWidth;
  const textNudgeY = Number(label?.textNudgeY);
  return (
    previewHeight -
    sourceTextCenterFromBottom * assetScale +
    (Number.isFinite(textNudgeY) ? textNudgeY * assetScale : 0)
  );
};
